import React from 'react';
import './ContactFormStyle.css';
import cartoon from '../images/cartoon-compressed.png';
import { FaEnvelope, FaPhone, FaLinkedin, FaGithub } from 'react-icons/fa';

const XIcon = ({ size = 22, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export default function ContactForm({ id }) {
  return (
    <div className='contact-window' id={id}>
      <h1>Let's Get in Touch.</h1>
      <p>Discuss a project or want to help or just want to say Hi? My Email and Phone is open for all.</p>
      <div className="contact-container">
        <img src={cartoon} alt='Contact' className="contact-wrapper-left"></img>
        <div className="contact-wrapper-right">
          <div className="contact-list">
            <a className="contact-item" href="mailto:akalrashid@outlook.com" aria-label="Email">
              <FaEnvelope className="contact-icon" size={22} />
              <div className="contact-text">akalrashid@outlook.com</div>
            </a>
            <a className="contact-item" href="tel:0509688559" aria-label="Phone">
              <FaPhone className="contact-icon" size={22} />
              <div className="contact-text" dir="ltr">0509688559</div>
            </a>
          </div>

          {/* Social links */}
          <div className="social-list">
            <a className="social-item" href="https://www.linkedin.com/in/akalrashid" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin className="contact-icon" size={22} />
              <div className="contact-text">LinkedIn</div>
            </a>
            <a className="social-item" href="https://github.com/Ahmed-1425/" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub className="contact-icon" size={22} />
              <div className="contact-text">GitHub</div>
            </a>
            <a className="social-item" href="https://x.com/akalrashid" target="_blank" rel="noopener noreferrer" aria-label="X">
              <XIcon className="contact-icon" size={22} />
              <div className="contact-text">X (Twitter)</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}